import * as React from "react";

class DialogOText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogO-text dialogLMNO-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 140.7 106.1"
      >
        <g>
          <path
            fill="#FCF8ED"
            d="M52.8,57.6c-0.4-0.5-1.1-1.1-1.8-1.8v3.1c0,1-0.2,1.4-0.8,1.7c-0.6,0.3-1.4,0.3-2.7,0.3
			c-0.1-0.5-0.3-1.3-0.6-1.8c0.7,0,1.5,0,1.7,0c0.3,0,0.3-0.1,0.3-0.3v-2.5c-0.9,0.7-1.9,1.4-2.7,1.9l-0.9-1.6
			c0.9-0.6,2.3-1.5,3.6-2.5v-4.4h-3.4v-1.9h3.4v-2.8h2v2.8h1.7c-0.3-0.6-0.9-1.4-1.5-2l1.4-0.8c0.6,0.5,1.3,1.4,1.6,1.9l-1.4,0.9H54
			v1.9h-3.1v2.3c0.4-0.6,0.9-1.2,1.1-1.8l1.7,0.7c-0.7,1.1-1.6,2.2-2.3,3c1,0.7,2.1,1.6,2.7,2.3L52.8,57.6z M47.3,50.5
			c0.6,0.9,1.3,2,1.5,2.8l-1.6,0.8c-0.2-0.8-0.9-2-1.4-2.9L47.3,50.5z M60.4,50.1c-0.3,2.4-0.8,4.5-1.7,6.3c0.8,1.2,1.7,2.1,2.9,2.8
			c-0.5,0.4-1.2,1.2-1.5,1.8c-1-0.7-1.8-1.6-2.6-2.7c-0.9,1.1-2,2.1-3.4,2.7c-0.3-0.5-1-1.3-1.5-1.7c1.7-0.7,2.9-1.7,3.9-3
			c-0.4-1-0.8-2-1.1-3.1c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3-0.4-1.1-1.2-1.5-1.5c1.4-1.8,2.1-4.7,2.5-7.8l2,0.3c-0.1,1-0.3,1.9-0.5,2.9
			h4.2v1.9H60.4z M56.6,50.1c-0.1,0.2-0.1,0.4-0.2,0.7c0.3,1.2,0.6,2.4,1.1,3.5c0.5-1.2,0.8-2.6,1-4.1H56.6z"
          />
          <path
            fill="#FCF8ED"
            d="M78,49.6c-0.2,7-0.3,9.5-0.9,10.3c-0.4,0.6-0.8,0.8-1.4,0.9c-0.5,0.1-1.4,0.1-2.3,0.1c0-0.5-0.2-1.4-0.6-1.9
			c0.8,0.1,1.6,0.1,2,0.1c0.3,0,0.4-0.1,0.6-0.3c0.4-0.5,0.5-2.6,0.7-8.1h-1.8c-0.3,4.5-1.2,8.1-4.5,10.4c-0.3-0.5-0.9-1.2-1.4-1.5
			c0.8-0.6,1.5-1.2,2-1.9c-2.6,0.7-5.4,1.3-7.5,1.8l-0.3-2.1c0.3-0.1,0.8-0.1,1.2-0.2V45.8h5.9v10.1l0.7-0.2l0.2,1.6
			c1.1-1.8,1.6-4,1.7-6.6H70v-1.9h2.2c0-1.2,0-2.4,0-3.7h2c0,1.3,0,2.5,0,3.7H78V49.6z M65.4,47.6v1.7h2.3v-1.7H65.4z M67.7,51.1
			h-2.3v1.8h2.3V51.1z M65.4,56.7c0.7-0.1,1.5-0.3,2.3-0.5v-1.6h-2.3V56.7z"
          />
          <path
            fill="#FCF8ED"
            d="M86.4,56.1l0.2,1.9c-2.2,0.5-4.6,1.1-6.4,1.5l-0.4-2c1-0.2,2.2-0.4,3.5-0.7c0.4-1.7,0.8-4.5,1-6.4l1.9,0.3
			c-0.3,1.9-0.8,4.1-1.2,5.7L86.4,56.1z M83.3,48h3.5v1.9h-6.8V48h2.9c-0.2-0.7-0.6-1.7-1-2.4l1.7-0.5c0.5,0.8,0.9,1.8,1.1,2.4
			L83.3,48z M82.1,50.5c0.4,1.8,0.7,4.1,0.8,5.6l-1.7,0.3c-0.1-1.5-0.4-3.9-0.7-5.7L82.1,50.5z M91.6,50.1v2.9H95V61h-2.1v-0.8h-4.1
			V61h-2v-8h2.7v-8h2.1v3.2h4v1.9H91.6z M92.9,55h-4.1v3.3h4.1V55z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogOText;



// WEBPACK FOOTER //
// ./src/rabbitCity/components/DialogOText.tsx